module.exports = __webpack_public_path__ + "static/img/review-like-active02.b4165495.svg";